<template>
    <v-dialog persistent v-model="dialog" width="40%">
        <v-card>
            <v-card-title><v-icon style="color: black;">mdi-link-variant-plus</v-icon>&nbsp;&nbsp;Create link</v-card-title>
            <br>
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols=12>
                        <v-text-field  dense v-model="url" label="URL"></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-text-field dense v-model="url_text" label="URL tekst"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <span class="float-right">
                            <v-icon v-on:click="closeCreateLink()" class="mt-2 ml-4">mdi-close</v-icon>
                        </span>
                        <span v-if="save_ok" class="float-right">&nbsp;<v-icon v-on:click="createLink(url, url_text)"
                                class="mt-2">mdi-content-save-outline</v-icon></span>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
  
<script>

import {bus} from "../main";  

export default {

    data() {
        return {
            dialog: false,
            links: [],
            url: '',
            url_text: '',
        }
    },
    computed: {
        save_ok: function () {
            return (this.url != '' && this.url_text != '');
        },
    },   
    mixins: [],
    methods: {
        open(array) {
            this.dialog = true;
            this.loading = false;
            this.url = '';
            this.url_text = '',
            this.links = array;

            // console.log(this.links);

        },
        notifyParent(param) {
            bus.$emit("createlink", param);
        },
        createLink(url, text) {
            
            // console.log(url, text);

            var idx = 0
            if (this.links != null && this.links.length > 0) {
                idx = this.links.length + 1;
            }

            // console.log(idx);

            var link = new Object();
            if(!url.toLowerCase().startsWith("http")){
                url = 'https://' + url;
            }
            var anchortag = '<A HREF="' + url + '" target="_blank">' + text + '</A>';            
            link.id = idx;
            link.url = anchortag;

            this.links.push(link);
            this.notifyParent(this.links);
            this.closeCreateLink();
        },
        closeCreateLink(){        
            this.dialog = false;
        },
    }
}
</script>
<style scoped>

</style>
  
  